module.exports = __webpack_public_path__ + "static/media/plan-oferta-wom-mas-300gb.75ab3ce4.svg";